class Random {
    static getRandomNumber(min: number, max: number) : number {
        return Math.floor(Math.random() * (max - min)) + min;
    }
}

export default Random;